import React from 'react';

import Icon from '../atom/Icon';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';

import ThemeStyle from '../../../lib/style/ThemeStyle';

const ActiveEvaluation = ({ rate, onMouseOut, onMouseOver, onClick }) => {
  return (
    <React.Fragment>
      <Flex
        onMouseOut={onMouseOut}
        justifyContent="space-between"
        width="9.5rem"
        padding="0.625rem 0"
      >
        {Array(5)
          .fill(0)
          .map((_, idx) => (
            <Icon
              key={idx}
              id={idx + 1}
              iconName="favorite"
              style={{
                color:
                  rate >= idx + 1 ? ThemeStyle.color.orangePink : '#d8d8d8',
              }}
              onMouseOver={onMouseOver}
              onClick={onClick}
            />
          ))}
      </Flex>
      <Text size={14} color="brownGrey">
        {RATE[rate - 1]}
      </Text>
    </React.Fragment>
  );
};

export default ActiveEvaluation;

const RATE = ['별로에요', '그저 그래요', '괜찮아요', '좋아요', '아주 좋아요!'];
